export enum TemplateTransportType {
  Email = 0,
  Postcard = 1,
  Sms = 2,
  Voice = 3,
  Letter = 4,
  IncomingSms = 5
}